module.exports = __webpack_public_path__ + "static/media/bg-image.a84a9d08.png";